import { Link } from 'react-router-dom';
import { MessageCircle, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';

export default function DoctorCard({ doctor }) {
  const whatsappUrl = `https://wa.me/${doctor.whatsapp_number}?text=${encodeURIComponent(
    `Hello! I would like to consult Dr. ${doctor.name}.`
  )}`;

  return (
    <div className="bg-white rounded-xl overflow-hidden border border-border/50 shadow-sm hover:shadow-md transition-all duration-300 group" data-testid={`doctor-card-${doctor.id}`}>
      <div className="relative h-80 bg-accent overflow-hidden">
        {doctor.photo_url ? (
          <img
            src={doctor.photo_url}
            alt={doctor.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-primary/10 to-secondary/10">
            <div className="w-32 h-32 bg-primary/20 rounded-full flex items-center justify-center">
              <span className="text-5xl font-heading text-primary">{doctor.name.charAt(0)}</span>
            </div>
          </div>
        )}
        {doctor.available && (
          <div className="absolute top-4 right-4 bg-green-500 text-white px-3 py-1 rounded-full text-xs font-medium flex items-center space-x-1">
            <CheckCircle size={14} />
            <span>Available</span>
          </div>
        )}
      </div>

      <div className="p-6">
        <h3 className="text-2xl font-heading font-semibold text-[#2D3436] mb-2">{doctor.name}</h3>
        <p className="text-sm text-[#636E72] mb-4">{doctor.qualifications}</p>

        <div className="mb-4">
          <h4 className="text-sm font-semibold text-[#2D3436] mb-2">Specializations:</h4>
          <div className="flex flex-wrap gap-2">
            {doctor.specializations.slice(0, 3).map((spec, idx) => (
              <span
                key={idx}
                className="px-3 py-1 bg-accent text-[#636E72] text-xs rounded-full"
              >
                {spec}
              </span>
            ))}
            {doctor.specializations.length > 3 && (
              <span className="px-3 py-1 bg-accent text-[#636E72] text-xs rounded-full">
                +{doctor.specializations.length - 3} more
              </span>
            )}
          </div>
        </div>

        <div className="flex gap-3">
          <Link to={`/doctors/${doctor.id}`} className="flex-1">
            <Button
              variant="outline"
              className="w-full border-primary text-primary hover:bg-primary hover:text-white rounded-full"
              data-testid={`view-profile-${doctor.id}`}
            >
              View Profile
            </Button>
          </Link>
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="flex-1">
            <Button
              className="w-full bg-[#25D366] hover:bg-[#20B558] text-white rounded-full"
              data-testid={`consult-whatsapp-${doctor.id}`}
            >
              <MessageCircle size={16} className="mr-2" />
              Consult
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
}